declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, AutoGenCsvList } from '../../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-csvlist',
    templateUrl: './autogencsvlist.component.html',
    styleUrls: ['./autogencsvlist.component.scss']
})

export class AutoGenCsvListComponent implements OnInit {
    @Input() public mode;    
    @Input()
    public FormMode: string = 'Edit';
    @Input() public field: FieldData;

    @Input() public Data: AutoGenCsvList;
 
    ngOnInit(): void {
        //this.Data = new AutoGenCsvList();
        //this.Data.ValueSourceName = this.field.ValueSource;
        if(this.Data != null)
            this.Data.parse();
    }
    @Input() SelectedValue: string = "";

}
